import script from "./MapElemInfoCar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapElemInfoCar.vue?vue&type=script&setup=true&lang=ts"

import "./MapElemInfoCar.vue?vue&type=style&index=0&id=71ce1c88&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71ce1c88"]])

export default __exports__